"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultValueGetter = () => true;
exports.mapReduce = (data, field, valueGetter = defaultValueGetter) => {
    return data.reduce((all, item) => {
        var _a;
        const key = (_a = item[field]) === null || _a === void 0 ? void 0 : _a.toString();
        if (key)
            all[key] = valueGetter(item);
        ;
        return all;
    }, {});
};
//# sourceMappingURL=mapReduce.js.map